import React from 'react';
import classNames from 'classnames';

import './index.less';

export enum LoadStatus {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  EMPTY = 'EMPTY',
  FAILURE = 'FAILURE',
  LOADING_WITH_CONTENT = 'LOADING_WITH_CONTENT',
}

interface IProps {
  className?: string;
  loadStatus: LoadStatus;
  children: React.ReactNode;
}

const LoadPlaceholder = (props: IProps) => {
  const { className, loadStatus, children } = props;

  const renderLoading = () => {
    return (
      <div className="page-loading">
        <img
          className="loading-icon"
          src="//s3plus-img.meituan.net/v1/mss_a15b7cd66e264e09b68e65865d5f8e2b/mtdx/mtdx-loading.gif"
          alt="loading"
        />
      </div>
    );
  };

  const renderEmpty = () => {
    return (
      <div className="page-empty">
        <img
          className="failure-icon"
          src="//img.meituan.net/mtdxweb/5c12a82487233ff4e69cd9d02440c3029232.png"
          alt="icon"
        />
        <div className="failure-text">暂无数据</div>
      </div>
    );
  };

  const renderSuccess = () => {
    return children;
  };

  const renderFailure = () => {
    const onRetryPage = () => {
      window.location.reload();
    };

    return (
      <div className="page-failure">
        <img
          className="failure-icon"
          src="//img.meituan.net/mtdxweb/5c12a82487233ff4e69cd9d02440c3029232.png"
          alt="icon"
          onClick={onRetryPage}
        />
        <div className="failure-text" onClick={onRetryPage}>
          加载失败，请点击重试
        </div>
      </div>
    );
  };

  const renderContent = () => {
    switch (loadStatus) {
      case LoadStatus.INITIAL:
      case LoadStatus.LOADING:
        return renderLoading();
      case LoadStatus.EMPTY:
        return renderEmpty();
      case LoadStatus.SUCCESS:
        return renderSuccess();
      case LoadStatus.FAILURE:
        return renderFailure();
      case LoadStatus.LOADING_WITH_CONTENT:
        return children;
      default:
        return null;
    }
  };

  return <div className={classNames('page-load-placeholder', `${className}`)}>{renderContent()}</div>;
};

export default LoadPlaceholder;
